import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Modal, Upload } from 'antd';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface UploadProjectSharedFileModalProps {
  visible: boolean;
  uploadProps: any;
  onUpload: (value: any) => void;
  onCancel: () => void;
}

function UploadProjectSharedFileModal({
  visible,
  uploadProps,
  onUpload,
  onCancel,
}: UploadProjectSharedFileModalProps) {
  const [form] = Form.useForm();
  const normFile = (e: any) => {
    let fileList = e.fileList;
    // fileList = fileList.slice(-1);

    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="공유 파일 올리기"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onUpload(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form form={form} layout="vertical" initialValues={{}}>
            <Form.Item
              name="file"
              label="공유 파일"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined rev={undefined} />}>
                  파일 올리기
                </Button>
              </Upload>
            </Form.Item>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default UploadProjectSharedFileModal;
